import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import authentication from './modules/authentication';
import workshop from './modules/workshop';
import truckType from './modules/truckType';
import truck from './modules/truck';
import driver from './modules/driver';
import jobcard from './modules/jobcard';
import jobcardFailure from './modules/jobcardFailure';
import jobcardMaintenance from './modules/jobcardMaintenance';
import jobcardSpare from './modules/jobcardSpare';
import externalWorkshop from "./modules/externalWorkshop";
import jobcardExternalMaintenance from './modules/jobcardExternalMaintenance';
import user from './modules/user';
import permission from './modules/permission';
import role from './modules/role';
import tireBrand from './modules/tireBrand';
import truckBrand from './modules/truckBrand';
import item from './modules/item';
import truckModel from './modules/truckModel';
import mileageReading from './modules/mileageReading';

export default new Vuex.Store({
  state: {
    locale: 'ar',
    locales: [
      { name: "عربي", code: "ar", rtl: true },
      { name: "English", code: "en", rtl: false }
    ]
  },
  getters: {
    
  },
  mutations: {
    setLocale(state, payload) {
      state.locale = payload;
    }
  },
  actions: {
    setLocale({commit}, payload) {
      commit("setLocale", payload);
    }
  },
  modules: {
    authentication,
    workshop,
    truckType,
    truck,
    driver,
    jobcard,
    jobcardFailure,
    jobcardMaintenance,
    jobcardSpare,
    externalWorkshop,
    jobcardExternalMaintenance,
    user,
    permission,
    role,
    tireBrand,
    truckBrand,
    item,
    truckModel,
    mileageReading
  }
})
